module.exports = __webpack_public_path__ + "img/tea_title--available.2c2d10c5.png";